// notifyDesktop creates a desktop notification via the browser api.
// If the permission is granted a desktop notification is sent.
export const notifyDesktop = (
  title: string,
  options?: globalThis.NotificationOptions
): boolean => {
  if (!window.Notification) {
    return false;
  } else if (Notification.permission === 'granted') {
    const _ = new Notification(title, options);

    return true;
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        const _ = new Notification(title, options);

        return true;
      }
    });
  }

  return false;
};

export default notifyDesktop;
